import { registerBlockType } from "@wordpress/blocks";
import {__} from "@wordpress/i18n";
import { InnerBlocks } from "@wordpress/block-editor";

const ALLOWED_BLOCKS=['spice-block/spice-social-icon'];

const socialIconsBlock = () => {
    return (
        <div className="social-block">
            <InnerBlocks 
                template={[
                    ['spice-block/spice-social-icon', ]
                ]}
            allowedBlocks={ALLOWED_BLOCKS} />
        </div>
    )
}

registerBlockType('spice-block/spice-socials',{
    title:__('Social Icons','spice-blocks'),
    icon:<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><ellipse ry="3" rx="3.1875" id="svg_1" cy="4.3416" cx="12.56799" stroke="#09A223" fill="#09A223"/><ellipse ry="3" rx="3.1875" id="svg_4" cy="17.09158" cx="4.1305" stroke="#09A223" fill="#09A223"/><ellipse ry="3" rx="3.1875" id="svg_5" cy="17.09158" cx="20.31798" stroke="#09A223" fill="#09A223"/><rect transform="rotate(-32.3881 16.7555 9.09159)" id="svg_6" height="7.24999" width="2.375" y="5.4666" x="15.56799" stroke="#09A223" fill="#09A223"/><rect transform="rotate(33.8254 7.25511 11.5463)" stroke="#09A223" id="svg_9" height="6.9389" width="2.375" y="8.0769" x="6.06761" fill="#09A223"/><rect transform="rotate(90 13.443 17.4041)" stroke="#09A223" id="svg_10" height="7" width="2.375" y="13.90409" x="12.25549" fill="#09A223"/></svg>,
    category:'spice-blocks',
    example: {
        'attributes' : {
            'mode' : 'preview',
        }
    },
    keywords:['Socials','Spice'],
    supports: {
    html: false,
    anchor: true,
    align: ['wide', 'full']
    },
    edit: socialIconsBlock,
    save:() => {
        return (
            <div className="social-block">
                <InnerBlocks.Content />
            </div>
        )
    }
});